import { apiUrls, tableColumnWidths } from 'consts'
import { Column, Sorting, TableColumnWidthInfo } from '@devexpress/dx-react-grid'
import getAll from 'utils/getAll'
import getGridColumnsProps from '../types/getGridColumnsProps'

const columnWidthsByColumnName = {
  serial_number: '10rem',
  days_since: '6rem',
}

const getGridColumns = async (): Promise<getGridColumnsProps> => {
  let data = await getAll(apiUrls.deviceTableConfig, false)

  let columns: Array<Column> = []
  let columnWidths: Array<TableColumnWidthInfo> = []
  let defaultSorting: Array<Sorting> = []

  data.forEach(
    (
      row: {
        id: number
        column_name: string
        label: string
        order: number
        visible: number
        default: number
      },
      index: number,
    ) => {
      columns.push({
        name: row.column_name,
        title: row.label,
      })
      columnWidths.push({
        columnName: row.column_name,
        width: columnWidthsByColumnName[row.column_name] ?? 'auto',
      })
      if (row.default === 1) {
        defaultSorting.push({
          columnName: row.column_name,
          direction: 'asc',
        })
      }
    },
  )

  columns.push({ name: 'action', title: 'Action' })
  columnWidths.push({ columnName: 'action', width: tableColumnWidths.action })

  return {
    columns: columns,
    columnWidths: columnWidths,
    sorting: defaultSorting,
  }
}

export default getGridColumns
